import { render, staticRenderFns } from "./skillCourse.vue?vue&type=template&id=46ec41d0&scoped=true"
import script from "./skillCourse.vue?vue&type=script&lang=js"
export * from "./skillCourse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46ec41d0",
  null
  
)

export default component.exports